/**
 * Created by lid4jcu on 11/01/2016.
 */
module.exports = function (bootstrap) {
    bootstrap.directive('feedbackFlash', ['$timeout', function ($timeout) {
        return {
            template: require('directives/hmhs/feedbackFlash.html'),
            link: function (scope, element, attr, ctrl) {

                //Feedback class so we can self-reference the messages.
                function FeedbackClass() {
                    this.messages = [];
                    this.limit = attr.limitShow ? attr.limitShow : 3;
                }

                //Add a message to the object to show in the directive.
                FeedbackClass.prototype.addFeedback = function (message, type, timer) {

                    var pushMessage = {
                        message: message,
                        type: type,
                        timer: timer
                    };

                    this.messages.push(pushMessage);

                    if (timer > 0) {
                        this.timerGo(timer, pushMessage);
                    }

                };

                // Remove Feedback, accepts ID, or original pushMessage for timers
                FeedbackClass.prototype.removeFeedback = function (id) {

                    //If Id is actually the message object
                    if (typeof id === 'object') {
                        //Find the message object in the array
                        id = this.messages.indexOf(id);
                    }

                    //If Id is valid
                    if (id > -1) {
                        //Splice the message ID out of the messages.
                        this.messages.splice(id, 1);
                    }

                };

                // Timeout function that sets up a timeout to remove a message.
                FeedbackClass.prototype.timerGo = function (timer, message) {

                    var here = this;
                    timer = timer * 1000;
                    $timeout(function () {
                                 here.removeFeedback(message);
                             }, timer
                    );

                };

                // Lets us set a custom scope for messages. useful if there are multiple flash bars.
                //Could use a way to instance to specific controller scopes, but was difficult to create dynamically with Angular
                //Only accepts one level deep of scoping.
                if (attr.scoping) {
                    //Sets to top level scope available for that variable.
                    scope[attr.scoping] = new FeedbackClass();
                }

                //Returns the dynamic variable we have set in attr.scoping.
                scope.getFlashes = function() {
                    return scope[attr.scoping];
                };

            }
        };
    }]);
};